export default __webpack_public_path__ + "06247f59734a2b4a960452cafd953c48.webp";